document.addEventListener('change', async (event) => {
  const checkbox = event.target.closest('.cart-subscription-upsell__checkbox');
  if (!checkbox || !checkbox.checked) return;

  const upsell = checkbox.closest('.cart-subscription-upsell');
  if (!upsell) return;

  const lineKey = upsell.dataset.lineKey;
  const quantity = parseInt(upsell.dataset.quantity || '1', 10);
  const sellingPlanId = parseInt(upsell.dataset.sellingPlanId || '', 10);

  if (!lineKey || !sellingPlanId) return;

  checkbox.disabled = true;
  upsell.classList.add('is-loading');

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity,
        selling_plan: sellingPlanId,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || 'Failed to update cart');
    }

    if (data.sections && data.sections['cart-drawer']) {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = data.sections['cart-drawer'];

      const currentDrawer = document.querySelector('#cart-drawer');
      const newDrawer = wrapper.querySelector('#cart-drawer');

      if (currentDrawer && newDrawer) {
        const currentItems = currentDrawer.querySelector('.cart-drawer__items');
        const newItems = newDrawer.querySelector('.cart-drawer__items');

        if (currentItems && newItems) {
          currentItems.replaceWith(newItems);
        }

        const currentButtonPrice = currentDrawer.querySelector('.cart-drawer__button-price');
        const newButtonPrice = newDrawer.querySelector('.cart-drawer__button-price');

        if (currentButtonPrice && newButtonPrice) {
          currentButtonPrice.replaceWith(newButtonPrice);
        }

        const currentFreeShipping = currentDrawer.querySelector('.free-shipping-bar, free-shipping-bar');
        const newFreeShipping = newDrawer.querySelector('.free-shipping-bar, free-shipping-bar');

        if (currentFreeShipping && newFreeShipping) {
          currentFreeShipping.replaceWith(newFreeShipping);
        }
      }
    }

    if (data.sections && data.sections['cart-icon-bubble']) {
      const bubbleWrapper = document.createElement('div');
      bubbleWrapper.innerHTML = data.sections['cart-icon-bubble'];

      const currentBubble = document.querySelector('#shopify-section-cart-icon-bubble');
      const newBubble = bubbleWrapper.querySelector('#shopify-section-cart-icon-bubble');

      if (currentBubble && newBubble) {
        currentBubble.replaceWith(newBubble);
      }
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
  } catch (error) {
    console.error(error);
    checkbox.checked = false;
    checkbox.disabled = false;
    upsell.classList.remove('is-loading');
  }
});